import branchServerClient from "web/core/branchServerClient";
import { compose, withProps } from "recompose";
import { graphql } from "react-apollo";

const removeInvalidCategories = (categories) =>
  categories
    .filter(({ include_in_menu }) => include_in_menu)
    .map((category) => ({
      ...category,
      children: category.children
        ? removeInvalidCategories(category.children)
        : [],
    }));

const EnhanceHeader = ({ HeaderQuery, HeaderUserQuery }) =>
  compose(
    graphql(HeaderQuery, {
      name: "data",
    }),
    withProps((props) => {
      return props.data
        ? {
            ...props,
            data: {
              ...props.data,
              navigationMenu: props.data.navigationMenu
                ? removeInvalidCategories(props.data.navigationMenu)
                : [],
              enterprise_menu_link: props.data.enterprise_menu_link,
              store_phone: props.data.store_phone,
              application_version: props.data.application_version,
              canDisplayLinkOnListing: props.data.canDisplayLinkOnListing,
              minimum_order_amount: props.data.minimum_order_amount,
              second_banner_is_active: props.data.second_banner_is_active,
              second_banner_text: props.data.second_banner_text,
              second_banner_background_color:
                props.data.second_banner_background_color,
              second_banner_text_color: props.data.second_banner_text_color,
            },
          }
        : props;
    }),
    branchServerClient(
      withProps({
        userData: {},
      }),
      graphql(HeaderUserQuery, {
        name: "userData",
      })
    )
  );

export default EnhanceHeader;
